module.exports = __webpack_public_path__ + "static/media/urbanprojectsa_qe_atmospheres_imsynthese15.6dadf841.webp";